<template>
    <div class="d-flex flex-wrap" v-if="items.length">
        <div class="col-3 text-center p-0 mb-4" v-for="(item, key) in items" :key="key" @click="itemAction(item)">
            <icon-tag class="item-icon icon-lg bg-white d-flex flex-wrap">
                <img :src="'data:image/svg+xml;base64,' + item.icon" v-if="item.iconType == 'SVG'" alt="" />
                <img class="h-50" :src="'data:image/png;base64,' + item.icon" v-else-if="item.iconType == 'JPG'" alt="" />
                <img class="h-35" :src="'images/icon-cat-more.svg'" v-else alt="" />
            </icon-tag>
            <span class="d-block font-sm mt-2">{{ item.name }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["items"],

        methods: {
            itemAction(item) {
                this.$emit('onItemPick', item)
            }
        },
    }
</script>

<style scoped>
    .item-icon {
        width: 3.125rem;
        height: 3.125rem;
    }
    .item-icon img {
        max-width: 80%;
        max-height: 80%;
    }
</style>